import { render, staticRenderFns } from "./ClinicianHomeView.vue?vue&type=template&id=0968eed8"
import script from "./ClinicianHomeView.vue?vue&type=script&lang=js"
export * from "./ClinicianHomeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports